"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => ({
    button: {
        position: 'relative',
        color: theme.grey3,
        appearance: 'none',
        backgroundColor: 'transparent',
        borderRadius: '50%',
        overflow: 'hidden',
        width: 24,
        height: 24,
        boxSizing: 'border-box',
        cursor: 'default',
        outline: 'none',
        display: 'block',
        '&::before': {
            content: '""',
            position: 'absolute',
            width: constants_1.MIN_TARGET_SIZE,
            height: constants_1.MIN_TARGET_SIZE,
            top: '50%',
            left: '50%',
            transform: 'translateY(-50%) translateX(-50%)'
        },
        '&[disabled]': {
            opacity: 0.3,
            color: theme.grey3
        },
        '&:not([disabled]):hover': {
            cursor: 'pointer',
            color: theme.grey1
        },
        '&:not([disabled])[aria-checked="true"]': {
            color: theme.grey3
        }
    }
});
//# sourceMappingURL=visibility.style.js.map